import { getNewsletterBannerTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { convertAssetsPathToRelativeLinks } from "@/utility/convertAssetsPaths";
import { NEWSLETTER_BANNER_EVENT_TYPES } from "@/constant";

const toRelativeContentUrls = data => {
  data.state1.content = convertAssetsPathToRelativeLinks(data.state1.content)?.body?.innerHTML;
  data.state1.disclaimerText = convertAssetsPathToRelativeLinks(data.state1.disclaimerText)?.body?.innerHTML;
  data.state2.content = convertAssetsPathToRelativeLinks(data.state2.content)?.body?.innerHTML;
  data.state2.confirmationMessage = convertAssetsPathToRelativeLinks(data.state2.confirmationMessage)?.body?.innerHTML;
};

const decodeFromNewsletterBannerData = element => {
  if (!element) {
    return {};
  }

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editNewsletterBannerConfig = (editor, shortcodeWrapper) => {
  let currentData = decodeFromNewsletterBannerData(shortcodeWrapper.getAttribute("data-newsletter-banner-data"));
  let isValid = null;

  const newsletterBannerWindow = editor.windowManager.openUrl({
    title: "Newsletter Banner",
    url: "/newsletter-banner-dialog",
    buttons: [
      { type: "cancel", name: "close", text: "Cancel" },
      { type: "custom", name: "submit", text: "Submit", primary: true },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        newsletterBannerWindow.sendMessage({
          type: NEWSLETTER_BANNER_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      editor.windowManager.alert("Success!");
      toRelativeContentUrls(currentData);
      shortcodeWrapper.setAttribute(
        "data-newsletter-banner-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === NEWSLETTER_BANNER_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === NEWSLETTER_BANNER_EVENT_TYPES.UPDATE_NEWSLETTER_BANNER_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === NEWSLETTER_BANNER_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 600,
  });

  const sendData = () => {
    let existData = decodeFromNewsletterBannerData(shortcodeWrapper.getAttribute("data-newsletter-banner-data"));
    newsletterBannerWindow.sendMessage({
      type: NEWSLETTER_BANNER_EVENT_TYPES.SEND_DATA,
      data: existData,
    });
  };
};

const newsletterBannerConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const newsletterBannerWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Newsletter Banner",
    url: "/newsletter-banner-dialog",
    buttons: [
      { type: "cancel", name: "close", text: "Cancel" },
      { type: "custom", name: "submit", text: "Submit", primary: true },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        newsletterBannerWindow.sendMessage({
          type: NEWSLETTER_BANNER_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getNewsletterBannerTemplate(),
        "newsletter-banner",
      );

      toRelativeContentUrls(currentData);
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(
        "data-newsletter-banner-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === NEWSLETTER_BANNER_EVENT_TYPES.REQUEST_DATA) {
        newsletterBannerWindow.sendMessage({
          type: NEWSLETTER_BANNER_EVENT_TYPES.SEND_DATA,
          data: {},
        });
      }

      if (message.mceAction === NEWSLETTER_BANNER_EVENT_TYPES.UPDATE_NEWSLETTER_BANNER_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === NEWSLETTER_BANNER_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 600,
  });
};

export { newsletterBannerConfig, editNewsletterBannerConfig };
